import { render } from "./NotesList.vue?vue&type=template&id=6ea47b9c"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__